import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const heartratefitnessApiService = createApi({
  reducerPath: "heartratefitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createHR: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `heartrate/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getHR: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `heartrate/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateHR: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `heartrate/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const { useCreateHRMutation, useGetHRQuery, useUpdateHRMutation } =
  heartratefitnessApiService;
